import styled from "styled-components";

export const NotFoundContainer = styled.div`
  background: rgb(63, 15, 64);
  background: linear-gradient(
    180deg,
    rgba(63, 15, 64, 1) 0%,
    rgba(108, 9, 110, 1) 96%
  );
  width: 100%;
  height: calc(100vh - 60px);
  margin: 60px 0 0 0;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  @media (min-width: 1000px) {
    margin: 60px 0 0 250px;
    
    > img {
      margin-top: 50px;
      width: 600px;
    }

    > h3 {
      margin-top: 40px;
    }

    > ul {
      > li {
        margin: 0 20px;
      }
    }
  }

  > img {
    margin: 50px 0;
    width: 200px;
  }


  > ul {
    display: flex;
    margin: 40px 0 0 0;
    padding: 0;
    list-style-type: none;

    > li {
      margin: 0 10px;

      > Button {
        color: white;
        border: 1px solid lightgray;

        :hover {
          background-color: lightgray;
          color: black;
        }

        > span > a {
          text-decoration: none;
          color: white;
        }
      }
    }
  }
`;
